import React from 'react'

export default props => (
	<div className='card' style={{ ...props.style, marginBottom: 0 }}>
		{props.children}
	</div>
)
